import { useQuery } from '@tanstack/react-query';
import { getChatMessages } from '../../../services/chatSupportService';

/**
 * Hook for fetching chat messages for a specific session
 * 
 * @param sessionId - The chat session ID
 * @param enabled - Whether the query should be enabled
 * @returns React Query result with chat messages
 */
export const useChatMessagesQuery = (sessionId: string | null, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['chat-messages', sessionId],
    queryFn: () => getChatMessages(sessionId!),
    enabled: enabled && !!sessionId,
    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
    refetchOnWindowFocus: false,
  });
};
